import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService, XpressDisciplinaryService, AppDataService } from 'app/services';
import { Utils } from 'app/utils';
import {
    XpressDisciplinaryStatus,
    XpressPriorityTypeModel,
    ServiceTypeEnum,
    XpressPriorityType, FieldTypeEnum
} from 'app/models';
import * as moment from 'moment';
import { PriorityIconUrls } from 'app/models/enums/disciplinary-priority-icon-urls.enum';
import { MenuHomeEnum } from 'app/components/home';
import { AppComponent } from 'app/app.component';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'home-disciplinary',
    templateUrl: './home-disciplinary.component.html',
    styleUrls: ['./home-disciplinary.component.scss',
        '../../../../styles/style-layout.scss',
        '../../../../styles/paginator.scss'
    ],
    providers: [MessageService]
})
export class HomeDisciplinaryComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    public fieldTypeEnum = FieldTypeEnum;
    public onboardingTitle: string = 'Disciplinary';
    public homeMenuEnum = MenuHomeEnum;
    public homeMenuActive!: MenuHomeEnum;
    @Input()
    set _homeMenuActive(value: MenuHomeEnum) {
        const valueIncludes = [MenuHomeEnum.DisciplinaryNewCases,
            MenuHomeEnum.DisciplinaryInProcess,
            MenuHomeEnum.DisciplinaryArchived].includes(value);
        if (valueIncludes) {
            this.homeMenuActive = value;
            this.setOnboardingTitle(value);
            this.updateBreadcrumbs();
        }
        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    public breadcrumbs: MenuItem[] = [{ icon: 'icon_back_office' }, { label: 'Application' }];

    constructor(
        private messageService: MessageService,
        private xpressDisciplinaryService: XpressDisciplinaryService,
        public configService: ConfigService,
        public appDataService: AppDataService,
        public app: AppComponent
    ) {}

    ngOnInit(): void {
        this.representativeFullName = this.appDataService.authData.userName;
        this.updateBreadcrumbs();
    }

    updateBreadcrumbs() {
        this.breadcrumbs = [{ icon: 'icon_back_office' }, { label: 'Application' }];
        if (this.app.backOfficeRoot.appData.isBoracayLocation) {
            this.breadcrumbs.push({ label: 'Drivers' });
        }
        this.breadcrumbs.push({ label: 'Disciplinary' });
        this.breadcrumbs.push({ label: this.onboardingTitle });
    }

    public arrayFilterStatuses: any = [
        { name: 'New', value: XpressDisciplinaryStatus.New },
        { name: 'Pending', value: XpressDisciplinaryStatus.Pending },
        { name: 'Suspended', value: XpressDisciplinaryStatus.Suspension }];

    public arrayFilterPriorities: any = [];
    public arrayFilterOffense: any = [];
    public arrayFilterDisciplinaryType: any = [];

    public cols: any[] = [
        { field: 'Status', name: 'DisciplinaryStatusText', fieldType: FieldTypeEnum.Dropdown, model: 'statusId',
            options: this.arrayFilterStatuses, placeholder: 'Please select', header: 'Status', width: '100px', active: false },
        { field: 'Priority', name: 'PriorityTypeId', fieldType: FieldTypeEnum.Dropdown, model: 'priorityId',
            options: this.arrayFilterPriorities, placeholder: 'Please select', header: 'Priority', width: '100px', active: false },
        { field: 'DisciplinaryId', name: 'DisciplinaryId', fieldType: FieldTypeEnum.InputNumber, model: 'disciplinaryId', placeholder: 'Type here',
            header: 'Disciplinary ID', width: '100px', active: false },
        { field: 'DriverName', name: 'DriverName', fieldType: FieldTypeEnum.Inputs, model: 'driverName', placeholder: 'Type here',
            header: 'Driver Name', width: '250px', active: false },
        { field: 'Offense', name: 'OffenseTypeText', fieldType: FieldTypeEnum.Dropdown, model: 'offenseId',
            options: this.arrayFilterOffense, placeholder: 'Please select', header: 'Offense', width: '100px', active: false },
        { field: 'DisciplinaryDate', name: 'CreatedAt', fieldType: FieldTypeEnum.Calendar, model: 'disciplinaryDate', placeholder: 'Select Date',
            header: 'Disciplinary Date', width: '100px', active: false },
        { field: 'Type', name: 'DisciplinaryTypeText', fieldType: FieldTypeEnum.Dropdown, model: 'disciplinaryTypeId',
            options: this.arrayFilterDisciplinaryType, placeholder: 'Please select', header: 'Type', width: '100px', active: false },
        { field: 'Code', fieldType: FieldTypeEnum.Inputs, model: 'code', placeholder: 'Type here',
            header: 'Code', name: 'CodeText', width: '100px', active: false },
        { field: 'UpdatedBy', name: 'UpdatedBy', fieldType: FieldTypeEnum.Inputs, model: 'updatedBy', placeholder: 'Type here',
            header: 'Updated by', width: '100px', active: false },
    ];
    public defaultCols = this.cols.map(x => x);

    // Grid settings
    public rowsPerPage: number = 50;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined };

    public loading: boolean = true;
    public visibleUserFilter: boolean = false;

    public showInfoPopup: boolean = false;
    public showEditFields: boolean = false;
    public infoPopupUser: any = undefined;

    public selectAll: boolean = false;

    public selectedUsers: Array<any> = [];
    public disciplinaryInfo: any;
    private searchTimer: number = 0;

    public xpressDisciplinaries: any = [];
    public disciplinaryId: number = 0;

    public disciplinaryHeaderSearch: any = {
        statusId: null,
        priorityId: null,
        disciplinaryId: null,
        driverName: null,
        offenseId: null,
        disciplinaryDate: null,
        disciplinaryTypeId: null,
        code: null,
        updatedBy: null,
        serviceType: null
    };
    public filterDisciplinaryRangeDate: Date[] | undefined;
    public showAddOrUpdateDisciplinarySideBar: boolean = false;
    public showDisciplinaryDetailSideBar: boolean = false;
    public showDisciplinaryInvestigationSideBar: boolean = false;
    public representativeFullName: string = '';

    public priorityTypeList = XpressPriorityTypeModel.XpressPriorityTypeList;

    public setOnboardingTitle(value: MenuHomeEnum) {
        switch (value) {
            case MenuHomeEnum.DisciplinaryNewCases:
                this.onboardingTitle = 'New Cases';
                break;
            case MenuHomeEnum.DisciplinaryInProcess:
                this.onboardingTitle = 'In Process';
                break;
            case MenuHomeEnum.DisciplinaryArchived:
                this.onboardingTitle = 'Archived';
                break;
            default:
                this.onboardingTitle = 'Disciplinary';
                break;
        }
    }

    onSelectedColumnsChange(event: any) {
        if (event && event.length > 0) {
            this.cols = event;
        } else {
            this.cols = this.defaultCols;
        }
    }

    public arrayFilterServiceType: any = [
        { name: 'All', value: null },
        { name: 'Ride', value: ServiceTypeEnum.Ride },
        { name: 'Send', value: ServiceTypeEnum.Delivery },
        { name: 'Eats', value: ServiceTypeEnum.Food },
        { name: 'Mart', value: ServiceTypeEnum.Grocery },
        { name: 'Rent', value: ServiceTypeEnum.Hire },
    ];

    public handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        this.sortField = event.sortField ? event.sortField : '';

        if (event.sortOrder) {
            this.sortOrder = event.sortOrder;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.onboardingTitle);
        }

        this.getRidersDisciplinaries(skip);
    }

    public getRidersDisciplinaries(skip: number) {
        this.loading = true;

        const dto = {
            DisciplinaryFilter: this.homeMenuActive,
            DisciplinaryStatusId: this.disciplinaryHeaderSearch.statusId,
            PriorityTypeId: this.disciplinaryHeaderSearch.priorityId,
            DisciplinaryId: this.disciplinaryHeaderSearch.disciplinaryId,
            DriverName: this.disciplinaryHeaderSearch.driverName,
            OffenseTypeId: this.disciplinaryHeaderSearch.offenseId,
            DisciplinaryDate: (!this.disciplinaryHeaderSearch.disciplinaryDate) ? null :
                moment(this.disciplinaryHeaderSearch.disciplinaryDate).format('YYYY-MM-DDTHH:mm:ss'),
            DisciplinaryTypeId: this.disciplinaryHeaderSearch.disciplinaryTypeId,
            Code: this.disciplinaryHeaderSearch.code,
            UpdatedBy: this.disciplinaryHeaderSearch.updatedBy,
            StartDisciplinaryRangeDate: (!this.filterDisciplinaryRangeDate) ? null : moment(this.filterDisciplinaryRangeDate[0]).format('YYYY-MM-DDTHH:mm:ss'),
            FinisDisciplinaryRangeDate: (!this.filterDisciplinaryRangeDate) ? null : (this.filterDisciplinaryRangeDate[1]) ? null :
                moment(this.filterDisciplinaryRangeDate[1]).format('YYYY-MM-DDTHH:mm:ss'),
            ClientLocationType: this.appDataService.getClientLocationType(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ServiceType: this.disciplinaryHeaderSearch.serviceType
        };

        this.xpressDisciplinaryService.getRidersDisciplinaries(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.xpressDisciplinaries = data.Items;
                this.xpressDisciplinaries.forEach((item: any) => {
                    item.CreatedAt = moment(item.CreatedAt).format('D MMM YYYY');
                    switch (item.DisciplinaryStatusId) {
                        case XpressDisciplinaryStatus.Suspension: {
                            item.StatusColor = '#F77F00';
                            item.StatusBackColor = '#FFEFCC';
                            item.DisciplinaryStatusText = (item.DisciplinaryPeriodDisplayText)
                                ? item.DisciplinaryStatusText + ' ' + item.DisciplinaryPeriodDisplayText
                                : 'No Suspension';
                            break;
                        }
                        case XpressDisciplinaryStatus.New: {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#0A84FF';
                            break;
                        }
                        case XpressDisciplinaryStatus.Pending: {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#818181';
                            break;
                        }
                        case XpressDisciplinaryStatus.Hearing: {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#00C0F0';
                            break;
                        }
                        case XpressDisciplinaryStatus.Investigating: {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#004060';
                            break;
                        }
                        case XpressDisciplinaryStatus.Meeting: {
                            item.StatusColor = '#004060';
                            item.StatusBackColor = '#CCD9DF';
                            break;
                        }
                        case XpressDisciplinaryStatus.Cleared: {
                            item.StatusColor = '#004060';
                            item.StatusBackColor = '#BAC5CB';
                            break;
                        }
                        case XpressDisciplinaryStatus.Banned: {
                            item.StatusColor = '#FFFFFF';
                            item.StatusBackColor = '#EB4236';
                            break;
                        }
                        case XpressDisciplinaryStatus.Closed: {
                            item.StatusColor = '#004060';
                            item.StatusBackColor = '#BAC5CB';
                            break;
                        }
                    }
                    this.setOrUpdatePriorityIcon(item);
                    this.mergePriorityDuplicates(item.PriorityTypeText, item.PriorityTypeId);
                    this.mergeOffenseDuplicates(item.OffenseTypeText, item.OffenseTypeId);
                    this.mergeDisciplinaryTypeDuplicates(item.DisciplinaryTypeText, item.DisciplinaryTypeId);
                });

                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
        this.mergePriorityDuplicates('All', null);
        this.mergeOffenseDuplicates('All', null);
        this.mergeDisciplinaryTypeDuplicates('All', null);
        this.mergeStatusTypeDuplicates('All', null);
    }
    setOrUpdatePriorityIcon(item: any){
        switch (item.PriorityTypeId) {
            case XpressPriorityType.Lowest: {
                item.PriorityIconUrl = PriorityIconUrls.Lowest;
                break;
            }
            case XpressPriorityType.Low: {
                item.PriorityIconUrl = PriorityIconUrls.Low;
                break;
            }
            case XpressPriorityType.Medium: {
                item.PriorityIconUrl = PriorityIconUrls.Medium;
                break;
            }
            case XpressPriorityType.High: {
                item.PriorityIconUrl = PriorityIconUrls.High;
                break;
            }
            case XpressPriorityType.Highest: {
                item.PriorityIconUrl = PriorityIconUrls.Highest;
                break;
            }
        }
    }

    public changePriority(disciplinary: any, priorityId: any) {
        const dto = {
            DisciplinaryId: disciplinary.DisciplinaryId,
            PriorityTypeId: disciplinary.PriorityTypeId
        };
        this.xpressDisciplinaryService.changePriority(dto, this.messageService)
            .then(data => {
                if (!data) {
                    return;
                }
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.setOrUpdatePriorityIcon(disciplinary);
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Priority updated' });
            })
            .catch(error => {
                console.log(error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
            });
    }

    public handleHeaderFilterChange(event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRidersDisciplinaries(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public mergePriorityDuplicates(name: string, value: any) {
        const exists = this.arrayFilterPriorities.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterPriorities.push({
                name,
                value
            });
        }
    }
    public mergeOffenseDuplicates(name: string, value: any) {
        const exists = this.arrayFilterOffense.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterOffense.push({
                name,
                value
            });
        }
    }
    public mergeDisciplinaryTypeDuplicates(name: string, value: any) {
        const exists = this.arrayFilterDisciplinaryType.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterDisciplinaryType.push({
                name,
                value
            });
        }
    }

    public mergeStatusTypeDuplicates(name: string, value: any) {
        const exists = this.arrayFilterStatuses.some((obj: any) => obj.name === name);
        if (!exists) {
            this.arrayFilterStatuses.push({
                name,
                value
            });
        }
    }

    public handleFilterChange(): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRidersDisciplinaries(0);
            this.searchTimer = 0;
        }, 1500);
    }

    public handleFilterClear(): void {
        this.filter.searchName = '';

        this.handleFilterChange();
    }

    public handleInfoPopupHide(): void {
        this.showInfoPopup = false;
    }

    public openUserFilter() {
        this.visibleUserFilter = !this.visibleUserFilter;
    }

    public openDisciplinarySideBar(disciplinary: any) {
        if (disciplinary.DisciplinaryStatusId === XpressDisciplinaryStatus.Suspension || disciplinary.DisciplinaryStatusId === XpressDisciplinaryStatus.Banned ||
            disciplinary.DisciplinaryStatusId === XpressDisciplinaryStatus.Closed) {
            this.openDisciplinaryDetailSideBar(disciplinary.DisciplinaryId);
        } else {
            this.openDisciplinaryInvestigationSideBar(disciplinary.DisciplinaryId);
        }
    }

    public handleInfoPopupShow(disciplinary: any) {
        this.disciplinaryInfo = disciplinary;
        this.showInfoPopup = !this.showInfoPopup;
    }

    public openAddOrUpdateDisciplinarySideBar() {
        this.showAddOrUpdateDisciplinarySideBar = true;
    }
    changedShowAddOrUpdateDisciplinarySideBarEmit(value: any) {
        this.showAddOrUpdateDisciplinarySideBar = value;
    }

    public openDisciplinaryDetailSideBar(disciplinaryId: number) {
        this.disciplinaryId = disciplinaryId;
        this.showDisciplinaryDetailSideBar = true;
    }
    changedShowDisciplinaryDetailSideBarEmit(value: any) {
        this.showDisciplinaryDetailSideBar = value;
    }

    public openDisciplinaryInvestigationSideBar(disciplinaryId: number) {
        this.disciplinaryId = disciplinaryId;
        this.showDisciplinaryInvestigationSideBar = true;
    }
    changedShowDisciplinaryInvestigationSideBarEmit(value: any) {
        this.showDisciplinaryInvestigationSideBar = value;
    }
}
